import React from 'react';

import styles from './index.module.scss';
import EditIconSvg from './../../svgs/EditIconSvg';
import CloseIconSvg from './../../svgs/CloseIconSvg';
import { useQueryClient } from 'react-query';
import { CartProps, ECart, EQuerykeys } from '../../../models';
import { cn } from '../../../lib/utils';

interface ICustomerDetails {
	setEdit: (arg?: boolean) => void;
	handleClear: (arg?: boolean) => void;
	showEditIcon?: boolean;
	showCancelIcon?: boolean;
}

const SingleCustomerDetail = ({
	setEdit,
	handleClear,
	showCancelIcon = true,
	showEditIcon = true,
}: ICustomerDetails) => {
	const queryClient = useQueryClient();

	const activeCartData: CartProps | undefined = queryClient.getQueryData([EQuerykeys.cart, ECart.active]);

	const { name, phoneNumber, email, organizationName } = activeCartData?.customer ?? {};

	return (
		<section className={`${styles.wrapper} flex-fill mx-4`}>
			<div className="d-flex justify-content-between align-items-center">
				{activeCartData?.customer ? (
					<div className="d-flex justify-content-between w-100">
						<div>
							<div className="flex align-items-center">
								<div>
									{organizationName ? (
										<div className={cn(styles.name, 'font-bold')}>{organizationName}</div>
									) : (
										<div className={styles.name}>{name}</div>
									)}
								</div>
								<div className={`${styles.divider}`} />
								<div className={styles.phone}>{phoneNumber}</div>
							</div>
							<div>
								<div className={styles.email}>{email}</div>
							</div>
						</div>

						<div className="d-flex align-items-center items-center gap-x-8">
							{showEditIcon && (
								<div className={`d-flex ${styles.editIcon}`} onClick={() => setEdit()}>
									<EditIconSvg />
								</div>
							)}
							{showCancelIcon && (
								<div className={styles.closeIcon} onClick={() => handleClear()}>
									<CloseIconSvg width="17" height="17" viewBox="0 0 25 25" />
								</div>
							)}
						</div>
					</div>
				) : (
					<div className={styles.name}>Walk In</div>
				)}
			</div>
		</section>
	);
};

export default SingleCustomerDetail;
